"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeJVMImportTransaction = exports.estimateJVMImportTransaction = exports.executeJVMExportTransaction = exports.estimateJVMExportTransaction = void 0;
const juneo_1 = require("../../../juneo");
const transaction_1 = require("../../../transaction");
const utils_1 = require("../../../utils");
const fee_1 = require("../fee");
async function estimateJVMExportTransaction(provider) {
    return new fee_1.BaseFeeData(provider.jvmChain, BigInt((await provider.info.getTxFee()).txFee), juneo_1.TransactionType.Export);
}
exports.estimateJVMExportTransaction = estimateJVMExportTransaction;
async function executeJVMExportTransaction(provider, wallet, destination, assetId, amount, address, sendImportFee, importFee, fee, utxoSet, extraFeeAmount = BigInt(0)) {
    const api = provider.jvmApi;
    const sender = wallet.getAddress(api.chain);
    const inputs = [new transaction_1.UserInput(assetId, api.chain, amount, [address], 1, destination)];
    if (extraFeeAmount > BigInt(0)) {
        inputs.push(new transaction_1.UserInput(destination.assetId, api.chain, extraFeeAmount, [address], 1, destination));
    }
    const exportAddress = wallet.getWallet(destination).getJuneoAddress();
    const transaction = (0, transaction_1.buildJVMExportTransaction)(inputs, utxoSet, [new transaction_1.Address(sender)], exportAddress, fee.amount, sendImportFee ? importFee : BigInt(0), sender, provider.mcn.id);
    const signedTx = await transaction.signTransaction([wallet.getWallet(api.chain)]);
    return (await api.issueTx(signedTx)).txID;
}
exports.executeJVMExportTransaction = executeJVMExportTransaction;
async function estimateJVMImportTransaction(provider) {
    return new fee_1.BaseFeeData(provider.jvmChain, BigInt((await provider.info.getTxFee()).txFee), juneo_1.TransactionType.Import);
}
exports.estimateJVMImportTransaction = estimateJVMImportTransaction;
async function executeJVMImportTransaction(provider, wallet, source, fee, utxoSet) {
    const api = provider.jvmApi;
    const sender = wallet.getAddress(api.chain);
    const values = (0, utils_1.getUtxosAmountValues)(utxoSet, source.id);
    const inputs = (0, utils_1.getImportUserInputs)(values, fee.assetId, fee.amount, source, api.chain, sender);
    const transaction = (0, transaction_1.buildJVMImportTransaction)(inputs, utxoSet, [new transaction_1.Address(sender)], fee.amount, sender, provider.mcn.id);
    const signedTx = await transaction.signTransaction([wallet.getWallet(api.chain)]);
    return (await api.issueTx(signedTx)).txID;
}
exports.executeJVMImportTransaction = executeJVMImportTransaction;
